export const projectTypes = {
    GET_PROJECTS_START:"GET_PROJECTS_START",
    GET_PROJECTS_SUCCESS:"GET_PROJECTS_SUCCESS",
    GET_PROJECTS_FAIL:"GET_PROJECTS_FAIL",
    
    GET_PROJECT_START:"GET_PROJECT_START",
    GET_PROJECT_SUCCESS:"GET_PROJECT_SUCCESS",
    GET_PROJECT_FAIL:"GET_PROJECT_FAIL",

}